module.exports = __webpack_public_path__ + "static/media/correct-2.54b2e4d8.mp3";